import { trackError } from '@billy/track-error'
import { useCallback, useRef } from 'react'

export const useFecImportFetchErrorTracking = () => {
  const hasReportedErrorRef = useRef(false)

  const onError = useCallback((error: unknown) => {
    if (hasReportedErrorRef.current) {
      return
    }

    hasReportedErrorRef.current = true
    trackError(new Error(`FEC imports fetch failed: ${error instanceof Error ? error.message : String(error)}`))
  }, [])

  const onSuccess = useCallback(() => {
    hasReportedErrorRef.current = false
  }, [])

  return { onError, onSuccess }
}
